import { Component, OnInit } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddGeoProvinceComponent } from '../add-geo-province/add-geo-province.component';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-geo-province',
  templateUrl: './geo-province.component.html',
  styleUrls: ['./geo-province.component.scss']
})
export class GeoProvinceComponent implements OnInit {
  tabs = tabs.GEO
  
  constructor(
    private router: Router,
    public store: List,
    private ds:DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddGeoProvinceComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.provinceRef(ref => ref.orderBy("code")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }



}
